import PageComponent from '../base/PageComponent';

class GridItem extends PageComponent {
  init() {
    this.bindLink();
  }

  /**
   * link a grid item if it has link data, bind with click and keypress
   */
  bindLink() {
    const $this = $(this.domElement());
    const url = $this.data('link');

    if ($this.hasClass('grid-item--has-link') && url) {
      $this
        .click(() => window.location.href = url)
        .keypress(e => {
          e.preventDefault();
          if (e.key && e.key === 'Enter' || e.key === ' ') {
            window.location.href = url;
          }
        });
    }
  }
}

export default GridItem;



// WEBPACK FOOTER //
// ./javascript/components/GridItem.js